export default "__VITE_ASSET__CgVb4iN2__"